<template>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" custom-class="signup-dialog"
               :show-close="!loading">
      <div class="dialog-body" v-loading="loading" element-loading-text="提交中，请稍后">
        <el-form ref="form" :model="form" :rules="rules" label-width="140px">
          <el-form-item label="训练场地" prop="siteName">
            <el-input v-model="form.siteName" disabled size="medium"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="form.projectName" disabled size="medium"></el-input>
          </el-form-item>
          <el-form-item label="学生姓名" prop="studentName">
            <el-input v-model="form.studentName" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="所在学校" prop="school">
            <el-input v-model="form.school" size="medium" placeholder="例：适之中学"></el-input>
          </el-form-item>
          <el-form-item label="所在班级" prop="classes">
            <el-input v-model="form.classes" size="medium" placeholder="例：102"></el-input>
          </el-form-item>
          <el-form-item label="学生身份证号" prop="idCard">
            <el-input v-model="form.idCard" placeholder="买保险需要使用"></el-input>
          </el-form-item>
          <el-form-item label="监护人名称" prop="guardian">
            <el-input v-model="form.guardian" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="监护人联系电话" prop="phone">
            <el-input v-model="form.phone" size="medium" style="width: 60%; margin-right: 10px;"></el-input>
            <el-button
              :disabled="isCountingDown"
              @click="sendVerificationCode"
              size="medium"
            >
              {{ countdownText }}
            </el-button>
          </el-form-item>
          <el-form-item label="验证码" prop="captchaCode">
            <el-input v-model="form.captchaCode" size="medium" style="width: 60%;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
<!--        <el-button @click="dialogVisible = false" :disabled="loading" size="medium">关 闭</el-button>-->
        <el-button type="primary" @click="confirmShow" :disabled="loading" size="medium">提 交</el-button>
      </div>
    </el-dialog>
</template>
<script>
  import {PostRequest,GetRequest} from "@/request";
  export default {
    name: "ProjectDialog",
    props: [],
    data() {
      return {
        loading: false,
        dialogVisible: false,
        dialogTitle: '报名信息填写',
        form:{
          siteName: '',
          projectName: '',
          school: '',
          classes: '',
          studentName: '',
          idCard: '',
          guardian: '',
          phone: '',
          captchaCode: '',
          projectId: null,
        },
        rules: {
          siteName: [
            { required: true, trigger: 'blur' },
          ],
          projectName: [
            { required: true, trigger: 'blur' },
          ],
          studentName: [
            { required: true, message: '请输入学生姓名', trigger: 'blur' },
          ],
          school: [
            { required: true, message: '请输入所在学校', trigger: 'blur' },
          ],
          classes: [
            { required: true, message: '请输入所在班级', trigger: 'blur' },
            { validator: this.validateClasses, trigger: 'blur' }
          ],
          idCard: [
            { required: true, message: '请输入学生身份证号', trigger: 'blur' },
            { validator: this.validateIdCard, trigger: 'blur' }
          ],
          guardian: [
            { required: true, message: '请输入监护人姓名', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入监护人联系电话', trigger: 'blur' },
            { pattern: /^\d{11}$/, message: '手机号必须是11位数字', trigger: 'blur' }
          ],
          captchaCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
        isCountingDown: false,
        countdownText: '发送验证码',
        countdown: 30,
      }
    },
    methods: {
      showDialog(site, project) {
        this.dialogVisible = true;
        this.form.captchaCode = '';
        this.form.siteName = site.siteName;
        this.form.projectName = project.projectName;
        this.form.projectId = project.projectId;
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

      confirmShow() {
        this.$refs.form.validate((res) => {
          if (res) {
            this.$confirm('请确认信息是否正确?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.doCommit()
            }).catch(() => {

            }).finally(() => {

            });
          }
        });

      },
      doCommit() {
        this.loading = true;
        let param = {
          ...this.form
        }
        PostRequest("/club/order", {
          ...param
        }, {
          headers: {
            isToken: false
          },
          hideError: true
        }).then((res) => {
          if (res.code == '200') {
            this.$emit('showQrCode', res.data);
            this.dialogVisible = false;
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
        }).catch((res) => {

        }).finally(() => {
          this.loading = false;
        });
      },
      validateClasses(rule, value, callback) {
        const numValue = Number(value);
        if (!value) {
          callback(new Error('请输入所在班级'));
        } else if (isNaN(numValue)) {
          callback(new Error('必须为数字'));
        } else if (numValue < 100 || numValue > 999) {
          callback(new Error('班级号必须是3位数字'));
        } else {
          callback();
        }
      },
      validateIdCard(rule, value, callback) {
        if (!value) {
          callback(new Error('请输入学生身份证号'));
        } else if (!/^\d{17}[\dX]$/.test(value)) {
          callback(new Error('身份证号格式不正确'));
        } else {
          callback();
        }
      },
      sendVerificationCode() {
        if (!this.form.phone) {
          this.$message.error('请输入监护人联系电话');
          return;
        }
        this.startCountdown();
        // 模拟发送验证码请求
        GetRequest("/sendCaptchaCode", { phone: this.form.phone }, {
          headers: {
            isToken: false
          },
          hideError: true
        }).then((res) => {
          if (200 === res.code) {
            this.$message.success(res.msg);
          } else if (601 === res.code) {
            this.$message.warning(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        }).catch((err) => {

        });
      },
      startCountdown() {
        this.isCountingDown = true;
        const timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
            this.countdownText = `${this.countdown}秒后重发`;
          } else {
            clearInterval(timer);
            this.isCountingDown = false;
            this.countdownText = '发送验证码';
            this.countdown = 30;
          }
        }, 1000);
      },
    },
  }
</script>
<style lang="less">
.signup-dialog{
  width: auto;
  max-width: 50%;
  .el-dialog__header {
    padding: 10px;
    background-color: #f3f7fa;
    border-radius: 5px 5px 0 0;
  }
  .el-dialog__body {
    width: 60%; /* 设置表单容器的宽度 */
    margin: 0 auto; /* 水平居中 */
    padding: 20px; /* 可选：增加内边距 */
  }

}
</style>
